module.exports = __webpack_public_path__ + "static/media/User_Group_People.baab97a4.svg";